import { BoxV4, ButtonV2 } from '@labrav/react-components'

import { CombinedFormState } from '../../../../modules/combinedForm/reducer'
import { faFileContract } from '@fortawesome/pro-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useStyles } from './EulaDetails.styles'
import { Typography } from '@mui/material'
import { useSelector } from '../../../../store'
import { Product } from '../../../../modules/productsListing/reducer'

interface EulaDetailsProps {
  combinedFormData: CombinedFormState
  viewingPersona: string
}

export default function EulaDetails({
  combinedFormData,
  viewingPersona,
}: EulaDetailsProps) {
  const { classes } = useStyles()
  const standardEulaUrl =
    'https://s3.amazonaws.com/aws-mp-standard-contracts/Standard-Contact-for-AWS-Marketplace-2022-07-14.pdf'
  const productIdToUse = combinedFormData?.resellerAgreementData.awsProductId
  const products = useSelector<Product[]>(
    state => state.productsListing['AWS']?.products?.rows || []
  )
  const product =
    products.find(product => product.productId === productIdToUse) ||
    ({} as Product)
  return (
    <BoxV4
      style={{ padding: '32px' }}
      heading="EULA details"
      headingIcon={
        <FontAwesomeIcon
          icon={faFileContract}
          style={{ width: '18px', height: '14px' }}
        />
      }
      variant="small"
      headingVariant="small"
    >
      <div className={classes.rowStyle}>
        <div className={classes.items}>
          <Typography className={classes.textStyle}>
            ISV Eula for buyer
          </Typography>
          <ButtonV2
            styleType="link"
            smallVariant
            onClick={() =>
              window.open(product.eulaUrl ? product.eulaUrl : standardEulaUrl)
            }
          >
            View Eula
          </ButtonV2>
        </div>
        {combinedFormData?.cppoData?.eulaFile?.[0] &&
        viewingPersona === 'CP' ? (
          <div className={classes.items}>
            <Typography className={classes.textStyle}>
              Reseller Eula for buyer
            </Typography>
            <ButtonV2
              styleType="link"
              smallVariant
              onClick={() =>
                window.open(combinedFormData?.cppoData?.eulaFile?.[0] ?? '')
              }
            >
              View Eula
            </ButtonV2>
          </div>
        ) : null}
      </div>
    </BoxV4>
  )
}
